import _ from "lodash";
import reporter from "../reporter";
import {generateError} from "../validations/errors";
import {validate} from "../validations/validation";

const locationType = 'GeoMapLocation';

function transformMarkersFromData(markers) {
    return _.map(markers, (marker) => ({
        address: marker.address,
        location: {
            longitude: marker.longitude,
            latitude: marker.latitude
        },
        icon: marker.pinIcon,
        link: _.isPlainObject(marker.link) ? marker.link.url : marker.link,
        title: marker.title,
        linkTitle: marker.linkTitle,
        description: marker.description
    }));
}

const validateMarkerLocation = ({location, address}, index = 0, propertyName, compName, compType) => {
    const validAddress = isValidAddress(address);
    const validLocation = isLocationObject(location) && validate({
        compType,
        functionName: propertyName,
        dataToValidate: location,
        compName
    });
    if (!validAddress && !validLocation) {
        reporter.reportSdkError(generateError.error_invalid_location({
            propertyName,
            index,
            wrongValue: JSON.stringify(location)
        }));
        return false;
    }
    return true;
};

function isNewGoogleMapsDataSchema(compData) {
    return _.isArray(compData.locations);
}

function validateMarker({compType, compName, marker, index}) {
    if (_.isNaN(_.get(marker.location, 'longitude'))) {
        delete marker.location.longitude;
    }
    if (_.isNaN(_.get(marker.location, 'latitude'))) {
        delete marker.location.latitude;
    }
    return validate({
        compType,
        functionName: 'markers',
        dataToValidate: marker,
        shouldCheckMandatoryFields: true,
        compName
    }) && validateMarkerLocation(marker, index, 'location', compName, compType);
}

function isLocationObject(location) {
    return _.isPlainObject(location) && _.isNumber(location.latitude) && _.isNumber(location.longitude);
}

function isValidAddress(address) {
    return _.isString(address) && _.size(address) > 0;
}

function isEmptyArrayOfMarkers(markers) {
    if (_.isEmpty(markers)) {
        reporter.reportSdkError(generateError.error_invalid_markers({
            wrongValue: JSON.stringify(markers)
        }));
        return true;
    }
    return false;
}

const defaultMarkerData = {
    address: '',
    latitude: NaN,
    longitude: NaN,
    title: '',
    description: '',
    link: null,
    linkTitle: '',
    pinIcon: '',
    type: locationType
};

function getLinkObject(linkUrl) {
    return {
        url: linkUrl,
        type: 'ExternalLink',
        target: '_blank'
    };
}

export {
    locationType,
    getLinkObject,
    validateMarker,
    isLocationObject,
    isEmptyArrayOfMarkers,
    transformMarkersFromData,
    isNewGoogleMapsDataSchema,
    defaultMarkerData
};



// WEBPACK FOOTER //
// ./js/modules/privates/utils/googleMapsUtils.es6